<!--
 * @Description: 
 * @Author: zml
 * @Date: 2025-05-09 09:20:56
 * @LastEditors: zml
 * @LastEditTime: 2025-05-13 10:57:35
-->
<template>
  <div class="container detail" v-html="language=== 'en' ? datas.enContent : language=== 'ru' ? datas.enContent : datas.content"></div>
</template>
<script>
import { mapState } from 'vuex'
import { GetContactInfo } from '@/api/home'

export default {
  name: 'pageDetail',
  data() {
    return {
      datas: {}
    }
  },
  computed: {
    ...mapState('operate', ['language'])
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      GetContactInfo().then(res => {
        if (res.success) {
          this.datas = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail {
  padding: 40px 0;

  & img {
    max-width: 100%;
  }
}
</style>
